import { Button, Card, CardActions, CardContent, Grid } from '@material-ui/core'
import { ChangeEvent, Dispatch, SetStateAction } from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import TextAreaInput from '../../Form/TextAreaInput'
import TextInput from '../../Form/TextInput'
import Message from '../../Message/Message'

const StyledSection = styled.section`
  h3 {
    margin-bottom: 30px;
  }

  .MuiCard-root {
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    color: white;
    padding-top: 75%;
    height: 100%;
    display: flex;
  }

  .MuiCardContent-root {
    background-color: rgba(0, 65, 92, 0.9);
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    h4 {
      margin-bottom: 15px;
    }

    p {
      margin-bottom: 30px;
    }
  }

  .MuiCardActions-root {
    padding: 0;
  }
`

interface BindType {
  value: string | boolean | undefined
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

interface SelectServiceProps {
  type: string
  setType: Dispatch<SetStateAction<string>>
  typeError: string
  bindName: BindType
  nameError: string
  bindDescription: BindType
  saveHandler: () => void
  loading: boolean
  handleCreateProject: () => void
  error: string
}

const SelectService = ({
  type,
  setType,
  typeError,
  bindName,
  nameError,
  bindDescription,
  saveHandler,
  loading,
  handleCreateProject,
  error,
}: SelectServiceProps) => {
  return (
    <StyledSection>
      <h4 className="m-b-30">Select service</h4>

      <Grid
        container
        spacing={4}
        className="services project-type-selector p-l-40 p-r-40"
      >
        <Grid item md={6} sm={6}>
          <div
            onClick={() => setType('programming')}
            className={`card-wrapper ${type === 'programming'
              ? 'selected'
              : type !== '' && 'not-selected'
              }`}
          >
            <Card
              style={{
                backgroundImage:
                  'url(/images/homepage/services/contract-programming.jpg)',
              }}
            >
              <CardContent>
                <div className="content">
                  <h4>Programming services</h4>
                  <p>
                    Getting expert assistance when you need it is vital to
                    maintaining manufacturing productivity. Whether you need new
                    CMM programs created for a new launch or have your existing
                    CMM programs optimized (cycle time, performance, etc.) when
                    production increases, a quote and program are only a few
                    short steps away.
                  </p>
                </div>
                <CardActions>
                  <Button
                    className={`btn-white ${type === 'programming' && 'selected'
                      }`}
                  >
                    {type === 'programming' ? 'Selected' : 'Select'}
                  </Button>
                </CardActions>
              </CardContent>
            </Card>
          </div>
          {typeError !== '' && (
            <Message
              style={{ marginTop: 10, marginBottom: -30 }}
              variant="danger"
            >
              {typeError}
            </Message>
          )}
        </Grid>

        <Grid item md={6} sm={6}>
          <div
            onClick={() => setType('inspection')}
            className={`card-wrapper ${type === 'inspection' ? 'selected' : type !== '' && 'not-selected'
              }`}
          >
            <Card
              style={{
                backgroundImage:
                  'url(/images/homepage/services/contract-inspection.jpg)',
              }}
            >
              <CardContent>
                <div className="content">
                  <h4>Inspection services</h4>
                  <p>
                    You might be down a system, have too much work, or you just
                    plain need somebody to do the work for you. We are here to
                    run full inspection services at one of our fully staffed
                    centers. We can provide an inspection report to optimizing a
                    program to meet desired cycle time or GR&R criteria. A quote
                    is only a few steps away.
                  </p>
                </div>
                <CardActions>
                  <Button
                    className={`btn-white ${type === 'inspection' && 'selected'
                      }`}
                  >
                    {type === 'inspection' ? 'Selected' : 'Select'}
                  </Button>
                </CardActions>
              </CardContent>
            </Card>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} className="">
        <Grid item xs={12}>
          <TextInput
            name="name"
            label="Project name"
            bindValue={bindName}
            error={nameError}
          />
        </Grid>

        <Grid item xs={12}>
          <TextAreaInput
            name="description"
            label="Project description (optional)"
            bindValue={bindDescription}
            rows={4}
            autoComplete="off"
            disabled={false}
          />
        </Grid>
      </Grid>

      <div className="actions m-t-30">
        <Button
          variant="contained"
          color="primary"
          onClick={saveHandler}
          disabled={loading}
          className={loading ? 'loading' : ''}
        >
          Save and exit
        </Button>

        <div>
          <Link to="/myquality/dashboard">
            <Button
              variant="outlined"
              color="primary"
              disabled={loading}
              className={loading ? 'loading' : ''}
            >
              Cancel
            </Button>
          </Link>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 20 }}
            onClick={handleCreateProject}
            disabled={loading}
            className={loading ? 'loading' : ''}
          >
            Next
          </Button>
        </div>
      </div>
      {error &&
        error !== 'Project name already exists. Please enter a new one.' &&
        error}
    </StyledSection>
  )
}

export default SelectService
